<template>
  <tr v-if="isShow">
    <th :class="getHeaderClass()">{{ properties.label }}</th>
    <td :class="{horizontal: properties.horizontal}">
      <div v-if="Array.isArray(properties.properties)"
          :class="{'flex':properties.horizontal}">
        <template v-for="(val, index) in properties.properties">
          <BaseCell
              :ref="`cell_${index}`"
              :key="index"
              :class="[val.class, {mt10: needMarginTop(index)}]"
              :properties="val"
              :display-item="displayItem"
              :editable="editable[val.editableId]"
              :site-code="siteCode"
              :validate-scope="validateScope"
              @input="(event, item, name) => onChange(val, event, item, name)"
              @focus="(event, item, name) => onFocus(val, event, item, name)"
              @blur="(event, item, name, before, after) => onBlur(val, event, item, name, before, after)">
            <span v-if="properties.colsep && index!==properties.properties.length-1"
                slot="colsep">{{ properties.colsep }}</span>
          </BaseCell>
        </template>
      </div>
    </td>
  </tr>
</template>

<style scoped>
.flex {
  display: flex;
}

th.required:after {
  content: " *";
  color: #ff5a5a;
  font-size: 85%;
}
td > .flex > :not(:last-child) {
  margin-right: 5px;
}
</style>

<script>
import _ from 'lodash'

import x from '@/components/mixins/mixin'

import BaseCell from '@/components/molecules/BaseCell'

export default {
  name: 'BaseTableDetailRow',
  components: {
    BaseCell
  },
  inject: ['parentValidator'],
  mixins: [x],
  props: {
    properties: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
    displayItem: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
    editable: {
      type: Object,
      default: () => {
        return {}
      }
    },
    siteCode: {
      type: String,
      default: null
    },
    validateScope: {
      type: String,
      default: null
    }
  },
  computed: {
    isShow () {
      if (this.properties.isShow != null || this.properties.funcId) {
        return (this.properties.isShow == null || this.executeIfPossible(this.properties.isShow)) &&
        (!this.properties.funcId || this.$isFunctionShown(this.properties.funcId))
      } else {
        // 内容が１つでも表示であれば表示
        return this.properties.properties.some((property) => {
          return (property.isShow == null || this.executeIfPossible(property.isShow)) &&
          (!property.funcId || this.$isFunctionShown(property.funcId))
        })
      }
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  methods: {
    getPropertyName (obj) {
      return obj.name ? obj.name : obj.path
    },
    getHeaderClass () {
      const hasRequired = _.chain(this.properties)
        .get('properties')
        .map(val => {
          if (!_.get(this.editable, val.editableId, false)) {
            return null
          }
          return typeof val.validateRule === 'function'
            ? val.validateRule(val)
            : val.validateRule
        })
        .filter(val => val != null)
        .join('|')
        .split('|')
        .find(val => val === 'required')
        .value() != null

      return `${this.properties.headerClass} ${hasRequired ? 'required' : ''}`
    },
    onChange (props, event, item, name) {
      this.$_mixin_updateValue(event, item, name)
      if (props.change) {
        props.change(event, item, name)
      }
    },
    onFocus (props, event, item, name) {
      if (props.focus) {
        props.focus(event, item, name)
      }
    },
    onBlur (props, event, item, name, before, after) {
      if (props.blur) {
        props.blur(event, item, name, before, after)
      }
    },
    findObject (obj, path) {
      let i = path.indexOf('.')
      if (i < 0) {
        return obj[path]
      }
      return this.findObject(obj[path.substr(0, i)], path.substr(i + 1))
    },
    needMarginTop (index) {
      return !this.properties.horizontal && index > 0
    },
    /**
     * obj が関数の場合、実行した結果を返却する.
     * obj が関数ではない場合、そのまま返却する.
     * @param {*} obj
     * @returns objの実行結果またはobj
     */
    executeIfPossible (obj) {
      return typeof obj === 'function' ? obj() : obj
    },
    focus (path) {
      const args = [].slice.call(arguments)
      args.splice(0, 1)
      const targetIndex = this.properties.properties.findIndex((element) => element.path === path)
      if (targetIndex >= 0) {
        this.$refs[`cell_${targetIndex}`][0].focus(...args)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/BaseTableDetailRow.vue